import type { AssessmentTemplate } from '@app/src/types/resourceExplorer'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import AnswerClassificationExplanation from '../AnswerClassificationExplanation'
import AssessmentMethodologyCard from '../Assessment/Methodology/AssessmentMethodologyCard'

interface AssessmentLearnMoreDialogProps {
  open: boolean
  onClose: () => void
  assessmentTemplate: AssessmentTemplate
}

const AssessmentLearnMoreDialog: React.FC<AssessmentLearnMoreDialogProps> = ({ open, onClose, assessmentTemplate }) => {
  const { formatMessage } = useIntl()

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ padding: '16px 24px' }}>{formatMessage({ id: 'general.learnMore' })}</DialogTitle>
      <Divider />
      <DialogContent sx={{ padding: '16px 48px 16px 48px' }}>
        <Typography
          variant="subtitle1"
          sx={{
            mb: 2,
            fontWeight: 600,
            lineHeight: '24px',
          }}
        >
          {formatMessage({ id: 'assessments.learnMore.howCompanyAssessed' })}
        </Typography>
        <Typography variant="body1" paragraph>
          {formatMessage(
            { id: 'assessments.learnMore.howCompanyAssessedDescription' },
            { requestName: assessmentTemplate.name },
          )}
        </Typography>

        <AssessmentMethodologyCard assessmentTemplate={assessmentTemplate} isTransparent />

        <Typography
          variant="subtitle1"
          sx={{
            mb: 2,
            mt: 4,
            fontWeight: 600,
            lineHeight: '24px',
          }}
        >
          {formatMessage({ id: 'assessments.learnMore.howAnswersAssessed' })}
        </Typography>
        <Typography variant="body1" paragraph>
          {formatMessage({ id: 'assessments.learnMore.howAnswersAssessedDescription' })}
        </Typography>

        <AnswerClassificationExplanation assessmentType={assessmentTemplate.assessmentType} />

        <Typography
          variant="subtitle1"
          sx={{
            mb: 2,
            mt: 4,
            fontWeight: 600,
            lineHeight: '24px',
          }}
        >
          {formatMessage({ id: 'assessments.learnMore.whoCanView' })}
        </Typography>
        <Typography variant="body1" paragraph>
          {formatMessage(
            { id: 'assessments.learnMore.whoCanViewDescription' },
            { requestName: assessmentTemplate.name },
          )}
        </Typography>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {formatMessage({ id: 'general.close' })}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AssessmentLearnMoreDialog
